import Header from '../../../components/header' 
import { useState, useEffect } from 'react'
import FieldNotificationsTable from '../components/FieldNotificationsTable'
import '../../../styles/App.css'
 
const FieldNotificationWindow = () => {
  
  const [notification, setNotification] = useState(false)

  useEffect(() => { 

    let switch_title = false

    const changeTitle = () => {
      if (switch_title) {
        document.title = 'SimpleFMS'
        switch_title = !switch_title
      } else {
        document.title = 'New TUM request'
        switch_title = !switch_title
      }
    }

    if (notification) {
      const interval = setInterval(changeTitle, 1000)

      return () => {
        clearInterval(interval)
      }
    } else {
      document.title = 'Field Notification Window'
    }
  }, [notification]);


  return(
    <div className="App" style={{ height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <header style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <Header title="Field Notifications" />
      </header>
      <main style={{ display: 'flex', justifyContent: 'center', width: '100%' }}> 
        <FieldNotificationsTable style={{ width: '100%' }} setNotificationSwitch={setNotification}/>
      </main>
    </div>
  )
}

export default FieldNotificationWindow